import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';

const HeaderLinks = props => {
  const { t } = useTranslation();
  const { onClickClose } = props;
  return (
    <IconButton fontSize='medium' color='transparent' tooltip={t('Clause.Item.BackToList')} onClick={onClickClose}>
      <ArrowBack />
    </IconButton>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired
};

export default HeaderLinks;
